import React, { useState } from "react";
import { Select, MenuItem, Switch, FormControl } from "@mui/material";

const ExportSettings = () => {
    const [resolution, setResolution] = useState("1080p");
    const [format, setFormat] = useState("mp4");
    const [captions, setCaptions] = useState(true);

    return (
        <div className="space-y-8 mt-[40px]  text-gray-800">
            {/* RESOLUTION */}
            <div className="flex justify-between items-center w-full">
                <div className="flex-1">
                    <div className="text-xl font-medium ">Resolution</div>
                    <div className="text-lg text-gray-500  mt-1">
                        Choose the resolution for the exported video.
                    </div>
                </div>
                <FormControl>
                    <Select
                        value={resolution}
                        onChange={(e) => setResolution(e.target.value)}
                        className="w-40  text-xl"
                        size="small"
                    >
                        <MenuItem value="480p">480p</MenuItem>
                        <MenuItem value="720p">720p</MenuItem>
                        <MenuItem value="1080p">1080p</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div className="border-b border-gray-300 my-4" />

            {/* FORMAT */}
            <div className="flex justify-between items-center w-full">
                <div className="flex-1">
                    <div className="text-xl font-medium ">Video Format</div>
                    <div className="text-lg text-gray-500  mt-1">
                        Select the file format you want to export as.
                    </div>
                </div>
                <FormControl>
                    <Select
                        value={format}
                        onChange={(e) => setFormat(e.target.value)}
                        className="w-40  text-xl"
                        size="small"
                    >
                        <MenuItem value="mp4">MP4</MenuItem>
                        <MenuItem value="mov">MOV</MenuItem>
                        <MenuItem value="webm">WEBM</MenuItem>
                        <MenuItem value="avi">AVI</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div className="border-b border-gray-300 my-4" />

            {/* CAPTIONS */}
            <div className="flex justify-between items-center w-full">
                <div className="flex-1">
                    <div className="text-xl font-medium ">
                        Generate Captions
                    </div>
                    <div className="text-lg text-gray-500  mt-1">
                        Automatically generate subtitles during export.
                    </div>
                </div>
                <Switch
                    checked={captions}
                    onChange={(e) => setCaptions(e.target.checked)}
                    color="primary"
                    className="text-xl"
                />
            </div>
        </div>
    );
};

export default ExportSettings;
